<div class="load-card loading--{{ context?.type }}" [class.condensed]="context?.isCondensed">
  ...
  <!-- {{ context.type }} -->
</div>
